import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const RejectItemModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "RejectItemModalContainer" */
      './RejectItemModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
